import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Translate } from '../translate';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()

/**
 * This class covers the translation functionality of the system.
 * All translations are registered in this file.
 */
export class TranslateService {
  // private languages = ['de-de', 'gb-en'];
  private settingFile = {};
  private languages = [];
  private loadCounter = 0;
  private dictionaries = {};
  private selectedLanguage: String = 'de-de';
  private defaultLanguage: String = 'gb-en';
  private baseUrl = 'assets/language/';
  private dictionary = {};
  private ready: Boolean;

  private subscribers: Translate[] = [];

  constructor(private http: Http, private localStorage: LocalStorageService) {
    this.ready = false;

    // Get cookie for language set
    // const lang: string = this.cookie.get('language');
    const lang: string = (this.localStorage.get('language')) ? this.localStorage.get('language').toString() : null;

    if (lang !== undefined && lang !== null) {
      this.selectedLanguage = lang;
    }

    // this.loadDictionaries();
    this.loadDictionarySettings();
  }

  public getSingleElementLanguage(): String {
    switch (this.selectedLanguage) {
      case 'de-de': return 'de';
      case 'gb-en': return 'en';
      default:
        return this.selectedLanguage.split('-')[0];
    }
  }

  /**
   * This function loads the setting file for multilanguage.
   * This file contains all available languages and their corresponding flag-icon
   */
  public loadDictionarySettings(): void {
    this.http.get(this.baseUrl + 'settings.json')
      .map(res => res.json())
      .subscribe(data => {
        // saving setting file
        this.settingFile = data;
        // Maping languages into a list
        const languages = [];
        for (let i = 0; i < data.languages.length; i++) {
          languages.push(data.languages[i].language);
        }
        this.languages = languages;
        this.loadDictionaries();
      }, error => {
        console.log('---TranslateService---: Failed to load setting file. TranslateService needs the setting file to work properly');
      });
  }



  /**
   * This function tries to load all dictionaries (json files) from system
   */
  public loadDictionaries(): void {
    for (let i = 0; i < this.languages.length; i++) {
      const errorLog = 'Failed to load resource for language: ' + this.languages[i];
      const iterationLanguage = this.languages[i];
      const obsJSON: Observable<JSON> = this.loadJSONFile(this.baseUrl + this.languages[i] + '.json');
      obsJSON.subscribe(data => this.dictionaryLoaded(data, iterationLanguage), error => { this.loadCounter++; console.log(errorLog) });
    }
  }

  /**
   * This function tries to load the file for the given path.
   * This Function returns an Observable<JSON> or null
   * @param filePath    path of the file to be loaded by service
   * @returns           returns a Observable<JSON>
   */
  public loadJSONFile(filePath: string): Observable<JSON> {
    return this.http.get(filePath)
      .map(res => res.json());
  }

  /**
   * This function is triggered after a dictionary file was loaded.
   * After loading the JSON it will be pushed to the dictionaries.
   * If the selectedLanguage is the actually loaded language then this will be set
   * as current dictionary
   *
   * @param data        JSON data from dictionary
   * @param language    corresponding language of dictionary
   */
  public dictionaryLoaded(data: JSON, language: string) {
    this.loadCounter++;
    this.dictionaries[language] = data;

    if (language === this.selectedLanguage) {
      this.dictionary = data;
      this.ready = true;
      this.notify();
    } else if (this.loadCounter >= this.languages.length) {
      this.dictionary = this.dictionaries[this.defaultLanguage + ''];
      this.ready = true;
      this.notify();
    }
  }

  /**
   * This function translates a defined key into the corresponding translated text
   *
   * @param key key of translation, look for further information in assets/language/xx-xx.json files
   */
  public translate(key: string): string {
    if (this.dictionary === {}) {
      return 'No dictionary found';
    } else {
      const word = this.dictionary[key];

      if (word === undefined || word === null) {
        return 'key not found in dictionary';
      } else {
        return word;
      }
    }
  }

  public selectLanguage(key: string): void {
    // this.cookie.set('language', key);
    this.localStorage.set('language', key);
    location.reload();

    const tmpDictionary = this.dictionaries[key];

    if (tmpDictionary === undefined || tmpDictionary === null) {
      this.dictionary = this.dictionaries[this.defaultLanguage + ''];
    } else {
      this.dictionary = tmpDictionary;
    }
  }

  /**
   * This function returns ready if the corresponding language file is loaded
   */
  public isReady(): Boolean {
    return this.ready;
  }

  public subscribe(callback: Translate): void {
    this.subscribers.push(callback);

    if (this.isReady()) {
      callback.readyTranslate(true);
    }
  }

  public notify(): void {
    for (const callback of this.subscribers) {
      callback.readyTranslate(true);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/translate.service.ts